// removed by extract-text-webpack-plugin
module.exports = {"information":"styles__information__3c-it","informationIcon":"styles__informationIcon__1jib5","informationTooltip":"styles__informationTooltip__14dg9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InformationTooltip/styles.css
// module id = 1695
// module chunks = 0